import { getState } from '../library/dataService';
import { isNative } from '../library/native';
import { RuntimeContext } from '../library/NGFieldExtensions';
import NGModalPopup from '../components/NGModalPopup/NGModalPopup';
import { useState } from 'react';
import { getCookie, setCookie } from '../library/utils';

// Helper function to get a specific cookie value


// Helper function to check if cookie consent banner has been shown and is still valid
function shouldShowConsentBanner(): boolean {
  const cookieValue = getCookie("User.Consent");
  if (!cookieValue) return true; // Show banner if no cookie exists

  try {
    const data = JSON.parse(decodeURIComponent(cookieValue));
    const now = new Date().getTime();
    const expiration = new Date(data.expires).getTime();
    // If expired, return true to show banner
    if (now > expiration) return true;

    // If not expired and value is true, don't show banner
    return data.shown !== true;
  } catch (error) {
    // If cookie is malformed, show banner
    return true;
  }
}

// Helper function to set the cookie consent banner shown flag with expiration
function setCookieConsentShown(consent: { [key: string]: boolean }): void {
  const now = new Date();
  const expiration = new Date(now.getTime() + (24 * 60 * 60 * 1000)); // 1 day from now

  const data = {
    shown: true,
    consent,
    expires: expiration.toISOString()
  };

  setCookie("User.Consent", encodeURIComponent(JSON.stringify(data)), 1);
}

export default function useCookieConsentBanner(context: RuntimeContext): () => JSX.Element {
  const { global } = getState(context);
  const user = global.User.value;
  const cookieConsent = global.TenantConfig.value?.CookieConsent || {};
  const userHasLoadedAndConsentIsNull = Object.keys(user || {}).includes("Consent") && user.Consent === null;

  const [hasBeenShown, setHasBeenShown] = useState(() => {
    return !shouldShowConsentBanner();
  });

  const shouldShowBanner = !isNative() &&
    cookieConsent?.Enabled &&
    cookieConsent?.ComponentId &&
    userHasLoadedAndConsentIsNull &&
    !hasBeenShown;

  if (!shouldShowBanner) return () => <></>;

  return () => (
    <NGModalPopup
      config={{
        Id: "cookie-consent-modal",
        __typename: "Dialog",
        Open: shouldShowBanner,
        ShowCloseButton: false,
        Slide: "up",
        ContentContainer: {
          __typename: "SimpleContainer",
          Id: `cookie_consent_container_${cookieConsent.ComponentId}`,
          Items: [
            {
              __typename: "Reference",
              Id: `cookie_consent_ref_${cookieConsent.ComponentId}`,
              ReferenceType: "Component",
              ReferenceId: cookieConsent.ComponentId,
              ReferenceSource: "Component",
            }
          ],
          Style: {
            display: "flex",
            flexDirection: "column",
          },
          IgnoreLayout: true
        },
        OnClose: (consent: { [key: string]: boolean }) => {
          setCookieConsentShown(consent);
          setHasBeenShown(true);
        }
      }}
      context={context}
    />
  );
}
